import {literalUnion} from '@raison/io-ts-tools';
import {TypeOf} from 'io-ts';

export const CardIconType = literalUnion(
    'visaelectron',
    'maestro',
    'forbrugsforeningen',
    'dankort',
    'visa',
    'mastercard',
    'amex',
    'dinersclub',
    'discover',
    'unionpay',
    'jcb',
    'cartes_bancaires'
);
export type CardIconType = TypeOf<typeof CardIconType>;
